import React from 'react';
import './AboutUs.css';
import Footer from './Footer';
// import { Link } from 'react-router-dom';
import Header from './Header';

const AboutUs = () => {
  return (
    <div>
      {/* Head */}
      {/* <section className="head">
        <div className="container flexSB">
          <div className="logo">
            <img src="/images/Asset7.png" alt="Academia Logo" className="logo-img" />
            <span>O Conteúdo que Precisas</span>
          </div>
          <div className="social">
            <i className="fab fa-facebook-f icon"></i>
            <i className="fab fa-instagram icon"></i>
            <i className="fab fa-twitter icon"></i>
            <i className="fab fa-youtube icon"></i>
          </div>
        </div>
      </section> */}

      {/* Header */}
      {/* <header>
        <nav className="flexSB">
          <ul className="flexSB">
            <li><a href="/">Início</a></li>
            <li><a href="/quem-somos">Quem Somos</a></li>
            <li><a href="/conteudo">Conteúdo</a></li>
            <li><a href="/contacto">Contacte-nos</a></li>
            <li><a href="/contacto">Baixe Coisas</a></li>
          </ul>
          <div className="start">
            <a href="/login" className="button">Iniciar Sessão</a>
          </div>
        </nav>
      </header> */}
      {/* <header>
      <nav className="flexSB">
        <ul className="flexSB">
          <li><Link to="/">Início</Link></li>
          <li><Link to="/AboutUs">Quem Somos</Link></li>
          <li><Link to="/ContentPage">Conteúdo</Link></li>
          <li><Link to="/ContactUs">Contacte-nos</Link></li>
          <li><Link to="/Downloads">Baixe Coisas</Link></li>
        </ul>
        <div className="start">
          <Link to="/Login" className="button">Iniciar Sessão</Link>
        </div>
      </nav>
    </header> */}
        <Header/>
      {/* Seção Quem Somos */}
      <section className="about-us-section">
        <div className="container">
          <div className="content-box left">
            <h2 className="try">Quem Somos</h2>
            <p className="tryu">
              A <strong>eBB</strong> é uma plataforma educacional criada para atender às necessidades dos estudantes moçambicanos, desde o ensino primário até a universidade. Nosso objetivo é fornecer acesso a conteúdos de alta qualidade, alinhados ao currículo moçambicano, com ferramentas que ajudam os alunos a aprenderem de forma eficaz e os professores a criarem aulas envolventes.
            </p>
          </div>

          <div className="imageBox"></div>

          <div className="content-box right">
            <h2 className="try">Nossa Missão</h2>
            <p className="tryu">
              Democratizar o acesso à educação de qualidade, capacitando alunos e professores com recursos digitais que facilitem o aprendizado e o ensino.
            </p>
          </div>

          <div className="imageBox2"></div>

          <div className="content-box left">
            <h2 className="try">Nossa Visão</h2>
            <p className="tryu">
              Ser a principal plataforma educacional em Moçambique, reconhecida por sua inovação e impacto positivo na educação.
            </p>
          </div>

          <div className="imageBox3"></div>

          <div className="content-box right">
            <h2 className="try">Nossos Valores</h2>
            <p className="tryu">
              <ul>
                <li><strong>Qualidade:</strong> Oferecemos conteúdos e ferramentas de alto padrão.</li>
                <li><strong>Acessibilidade:</strong> Educação para todos, independentemente da localização.</li>
                <li><strong>Inovação:</strong> Utilizamos tecnologia para transformar a educação.</li>
              </ul>
            </p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default AboutUs;